import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IPromotionsIconProps extends ISvgIconProps {

}

export class PromotionsIcon extends React.Component<IPromotionsIconProps> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 19 18" fill={'none'}>
                <g clipPath="url(#clip0_11018_281862)">
                    <path d="M16.6723 5.37109H1.91601C1.57218 5.37109 1.29346 5.65029 1.29346 5.9947V7.59717C1.29346 7.94158 1.57218 8.22078 1.91601 8.22078H16.6723C17.0161 8.22078 17.2949 7.94158 17.2949 7.59717V5.9947C17.2949 5.65029 17.0161 5.37109 16.6723 5.37109Z" stroke="currentColor" strokeWidth="1.11121" strokeMiterlimit="10"/>
                    <path d="M2.05176 8.2168H16.537V16.3742C16.537 16.7186 16.2582 16.9978 15.9144 16.9978H2.67431C2.3305 16.9978 2.05176 16.7186 2.05176 16.3742V8.2168Z" stroke="currentColor" strokeWidth="1.11121" strokeMiterlimit="10"/>
                    <path d="M7.7998 8.22266V17.0043" stroke="currentColor" strokeWidth="1.11121" strokeMiterlimit="10"/>
                    <path d="M10.7896 8.22266V17.0043" stroke="currentColor" strokeWidth="1.11121" strokeMiterlimit="10"/>
                    <path d="M10.7896 5.37402V8.24252" stroke="currentColor" strokeWidth="1.11121" strokeMiterlimit="10"/>
                    <path d="M7.7998 5.37402V8.24252" stroke="currentColor" strokeWidth="1.11121" strokeMiterlimit="10"/>
                    <path d="M9.52962 5.37587C9.52962 5.37587 9.4888 2.4821 11.2774 1.28216C12.7649 0.284135 14.6281 2.13579 13.508 3.68395C13.1093 4.23472 12.0141 5.27492 9.53026 5.37587H9.52962Z" stroke="currentColor" strokeWidth="1.11121" strokeMiterlimit="10"/>
                    <path d="M9.05902 5.37587C9.05902 5.37587 9.09984 2.4821 7.31128 1.28216C5.82378 0.284135 3.96059 2.13579 5.08068 3.68395C5.47934 4.23472 6.57455 5.27492 9.05838 5.37587H9.05902Z" stroke="currentColor" strokeWidth="1.11121" strokeMiterlimit="10"/>
                </g>
                <defs>
                    <clipPath id="clip0_11018_281862">
                        <rect width="18" height="18" fill="currentColor" transform="translate(0.290039)"/>
                    </clipPath>
                </defs>
            </SvgIcon>
        );
    }
}
